import React, { useState } from "react";
import upload from "../../utils/upload";
import "./Register.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Register = () => {
  const [user, setUser] = useState({
    username: "",
    email: "",
    password: "",
    img: "",
    country: "",
    phone: "",
    isSeller: false,
    desc: "",
  });
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  //handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = await upload(file);
    try {
      const res = await axios.post("http://localhost:8800/api/auth/register", {
        ...user,
        img: url,
      });
      navigate("/");
      toast.success(res?.data);
    } catch (err) {
      toast.error(err?.response?.data.message || "An error occurred");
    }
  };

  //handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name) {
      setUser((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  //handle Seller
  const handleSeller = (e) => {
    setUser((prev) => {
      return { ...prev, isSeller: e?.target?.checked };
    });
  };
  return (
    <div className="register">
      <form onSubmit={handleSubmit}>
        <div className="left">
          <h1>Create a new account</h1>
          <label htmlFor="">Username</label>
          <input
            type="text"
            name="username"
            placeholder="Username"
            onChange={handleChange}
          />
          <label htmlFor="">Email</label>
          <input
            name="email"
            type="email"
            placeholder="Email"
            onChange={handleChange}
          />
          <label htmlFor="">Password</label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
          />
          <label htmlFor="">Profile Picture</label>
          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          <label htmlFor="">Country</label>
          <input
            name="country"
            type="text"
            placeholder="Usa"
            onChange={handleChange}
          />
          <button type="submit">Register</button>
        </div>
        <div className="right">
          <h1>I want to become a seller</h1>
          <div className="toggle">
            <label htmlFor="">Activate the seller account</label>
            <label className="switch">
              <input type="checkbox" onChange={handleSeller} />
              <span className="slider round"></span>
            </label>
          </div>
          <label htmlFor="">Phone Number</label>
          <input
            name="phone"
            type="text"
            placeholder="+1 234 567 89"
            onChange={handleChange}
          />
          <label htmlFor="">Description</label>
          <textarea
            placeholder="A short description of yourself"
            name="desc"
            id=""
            cols="30"
            rows="10"
            onChange={handleChange}
          ></textarea>
        </div>
      </form>
    </div>
  );
};

export default Register;
